module.exports = __webpack_public_path__ + "45a32a3263c6cc1c73b82c3332ccb898.svg";